import React from "react";
import "./GetStartedHero.css";

const GetStartedHero = ({title = "출판 상담 신청"}) => {
  return (
    <section className="get-started-hero">
      <h1 className="hero-title">{title}</h1>
    </section>
  );
};

export default GetStartedHero;
